/* AppListing.styles.ts generated by @compiled/babel-plugin v0.29.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import * as React from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _9 = "._1bsb1osq{width:100%}";
const _8 = "._18s81hdg{margin:var(--ds-space-400,2pc) 0 var(--ds-space-800,64x) 0}";
const _7 = "._19pk1jfw{margin-top:var(--ds-space-500,40px)}";
const _6 = "._otyr1eps{margin-bottom:var(--ds-space-100)}";
const _5 = "._19pkgosd{margin-top:var(--ds-space-500)}";
import { media } from '@atlaskit/primitives/responsive';
const _4 = "@media (min-width:64rem){._13wnstnw{position:absolute}._1r6vze3t{right:var(--ds-space-0,0)}._hyzq11wp{z-index:3}._dbjg12x7{margin-top:var(--ds-space-075,6px)}}";
const _3 = "._otyr12x7{margin-bottom:var(--ds-space-075,6px)}";
const _2 = "._kqswh2mm{position:relative}";
const _ = "._1ul91ns9{min-width:-moz-fit-content;min-width:fit-content}";
export const HostingSelectContainerV1 = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1ul91ns9 _kqswh2mm _otyr12x7 _13wnstnw _1r6vze3t _hyzq11wp _dbjg12x7", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  HostingSelectContainerV1.displayName = 'HostingSelectContainerV1';
}
export const HostingSelectContainerV2 = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_5, _6]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pkgosd _otyr1eps", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  HostingSelectContainerV2.displayName = 'HostingSelectContainerV2';
}
export const ListingContainer = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_7]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pk1jfw", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ListingContainer.displayName = 'ListingContainer';
}
export const TabContentContainer = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_8, _9]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_18s81hdg _1bsb1osq", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  TabContentContainer.displayName = 'TabContentContainer';
}